import React, { Component } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import { connect } from 'react-redux';
import GridExample from '../tools/EditableTable';
import { Button, Input } from 'reactstrap';
import { ModuleRegistry } from 'ag-grid-community';
import { CheckboxEditorModule } from 'ag-grid-community'; 

ModuleRegistry.registerModules([CheckboxEditorModule]); 

class Exxat extends Component {
    static displayName = Exxat.name;

    constructor(props) {
        super(props);
        this.state = {
            permissionFlag: true,
            eventOptions: [],
            activeEvent: "DEFAULT",
            bearerVAR: "Bearer " + this.props.reduxData.apiKey,
            tableRerender: 1
        }
        this.testPermission();
        this.getOptions();
    }

    async testPermission() {
        this.props.updateFetchTime()
        let toSend = {
            userLevel: this.props.reduxData.userInfo.level.pk,
            pagepk: "/Exxat"
        }
        const response = await fetch('ValidDepartments', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': this.state.bearerVAR },
            body: JSON.stringify(toSend)
        })
        const data = await response.json();
        this.setState({
            permissionFlag: data
        })
    }

    async getOptions() {
        this.props.updateFetchTime()
        let toSend = {
            userLevel: this.props.reduxData.userInfo.level.pk
        }
        const response = await fetch('ExxatGetEvents', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': this.state.bearerVAR },
            body: JSON.stringify(toSend)
        })
        const data = await response.json();
        this.setState({
            eventOptions: data
        })
    }

    async addEvent() {
        this.props.updateFetchTime()
        let toSend = {
            userLevel: this.props.reduxData.userInfo.level.pk,
            eventid: this.state.activeEvent
        }
        const response = await fetch('ExxatAddEvent', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': this.state.bearerVAR },
            body: JSON.stringify(toSend)
        })
        const data = await response.json();
        this.setState({
            activeEvent: "DEFAULT",
            tableRerender: this.state.tableRerender + 1
        })
        console.log("tableRerender: " + this.state.tableRerender)
        this.getOptions();
    }

    render() {
        if (this.state.permissionFlag == false) {
            this.props.passNewPage(-1);
        }
        return (<div>
            <div className="quarterOfParent">
                <Input type="select" name="event" id="event" value={this.state.activeEvent} onChange={(e) => this.setState({ activeEvent: e.target.value })}>
                    <option value="DEFAULT" disabled>Select...</option>
                    {this.state.eventOptions.map(item => (
                        <option value={item.eventid}>{item.eventid}</option>
                    ))}
                </Input>
                <div className="inlineCustom"><Button onClick={() => this.addEvent() }>Add</Button></div>
            </div>
            <br />
            <div style={{ height: 650 }}><GridExample queryToRun={2} key={this.state.tableRerender} rerenderCallback={this.getOptions.bind(this)} /></div>
        </div>)
    }
}

const mapStateTo = state => ({
    reduxData: state
})

const mapDispatchTo = (dispatch) => {
    return {
        updateFetchTime: () => dispatch({ type: 'foundation/setFetchTime' })
    }
}

export default connect(mapStateTo, mapDispatchTo)(Exxat);